import { FileType } from "@bpm/models";
import { Status } from "./status";

export class PdcaFile{
    id?: number;
    documentName: string;
    documentUrl: string;
    fileType: FileType;
    comment: string;
    commentEnglish: string;
    status: Status;
}